import { TableColumnMeta } from "ds/components/Table/types";

export const STACKS_COLUMNS_STORAGE_KEY = "stacksColumnsConfig";

export enum STACKS_COLUMN_ID {
  NAME = "NAME",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

export const STACKS_COLUMN_CONFIG: Record<STACKS_COLUMN_ID, TableColumnMeta> = {
  [STACKS_COLUMN_ID.NAME]: {
    id: STACKS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 160,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
  },
  [STACKS_COLUMN_ID.ROW_ACTIONS]: {
    id: STACKS_COLUMN_ID.ROW_ACTIONS,
    title: "Stack actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
  },
};
